import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { BulkTIDMID as Update } from 'Components/Api/NSDLOnboardingAPI';
import {
    Container,
    Grid,
    Paper,
    MenuItem,
    TextField,
    CircularProgress,
    Typography,
    Box
} from '@material-ui/core';
import { useHistory } from 'react-router';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';

const CustomContainer = HOCLoader(Container);

export const BulkUpdateTIDMID = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [document, setDocument] = useState('');
    const [fileSelected, setFileSelected] = useState(false);
    const [selectedFileName, setSelectedFileName] = useState('');
    const [successRecords, setSuccessRecords] = useState(0);
    const [failedRecords, setFailedRecords] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);

    const [successData, setSuccessdata] = useState([]);
    const [failedData, setFailedData] = useState([]);
    const [userNotFoundRecords, setUserNotFoundRecords] = useState([]);

    const handleSubmit = async (values, { resetForm }) => {
        if (loading) return;
        setLoading(true);
        setIsError(false);

        const response = await Update(JSON.stringify(values));

        var data = JSON.parse(response.data);
        setLoading(false);

        if (!response.isAuthorized) {
            LOGOUT();
            return;
        }

        if (!response.status) {
            setResponseMessage(data.Message);
            setSeverity('error');
            setIsError(true);
            return;
        }
        // Set report data
        setSuccessRecords(data.successfulUpdates);
        setFailedRecords(data.failedRecords);
        setTotalRecords(data.totalRecords);

        setSuccessdata(data.successfulRecords);
        setFailedData(data.list);
        setUserNotFoundRecords(data.userNotFoundRecords);

        if (data.successfulUpdates > 0) {
            setSeverity('success');
            setResponseMessage("All TID MID Updated Successfully.");
            setIsError(true);
        }


        resetForm();
        setFileSelected(false);
        setSelectedFileName('');
        setDocument('');
    };
    const FormObj = {
        ExcelDocument: { Name: '', Size: '', Type: '', Data: '' }
    };

    const FormValidationSchema = Yup.object({
        // ExcelDocument: Yup.object().shape({
        //     Type: Yup.string()
        //         .required(PLEASE_PROVIDE_VALID + ' file')
        //         .matches(/\.(xlsx|xls|csv)$/i, "Only .xlsx, .xls, .csv files allowed"),
        //     Data: Yup.string().required("File data is required"),
        // }),
    });

    const UploadForm = (formProps) => {
        const fileInputRef = React.useRef(null);

        const handleFileAreaClick = () => {
            fileInputRef.current?.click();
        };

        return (
            <Form style={{ marginBottom: 15 }}>
                <Paper className={classes.PaperStyle}>
                    <Grid
                        container
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        spacing={4}
                        style={{ minHeight: 300, padding: 24 }}
                    >
                        <Grid item xs={6} style={{ width: '100%' }}>
                            <Paper
                                elevation={3}
                                style={{
                                    padding: 20,
                                    borderRadius: 16,
                                    backgroundColor: fileSelected ? '#e8f5e8' : '#ffffff',
                                    border: fileSelected ? '2px solid #4caf50' : '2px dashed #cccccc',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                    minHeight: 120
                                }}
                                onClick={handleFileAreaClick}
                            >
                                <Box textAlign="center" mb={2}>
                                    {selectedFileName && (
                                        <Typography variant="h6" color="primary" style={{ marginTop: 8 }}>
                                            {selectedFileName}
                                        </Typography>
                                    )}
                                </Box>

                                <TextField
                                    fullWidth
                                    type="file"
                                    inputProps={{
                                        accept: '.xlsx,.xls,.csv',
                                        style: {
                                            padding: '10px 0',
                                            borderRadius: 8
                                        }
                                    }}
                                    InputProps={{
                                        style: {
                                            borderRadius: 12,
                                            backgroundColor: fileSelected ? '#f1f8e9' : '#fafafa'
                                        }
                                    }}
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (!file) {
                                            setFileSelected(false);
                                            setSelectedFileName('');
                                            return;
                                        }

                                        const ext = file.name.split('.').pop()?.toLowerCase();
                                        if (!['xlsx', 'xls', 'csv'].includes(ext)) {
                                            formProps.setFieldError('ExcelDocument.Type', 'Invalid file type');
                                            setFileSelected(false);
                                            setSelectedFileName('');
                                            return;
                                        }

                                        setDocument(URL.createObjectURL(file));
                                        setFileSelected(true);
                                        setSelectedFileName(file.name);
                                        formProps.setFieldValue('ExcelDocument.Name', file.name);
                                        formProps.setFieldValue('ExcelDocument.Size', file.size);
                                        formProps.setFieldValue('ExcelDocument.Type', file.type);

                                        const reader = new FileReader();
                                        reader.onload = (event) => {
                                            formProps.setFieldValue(
                                                'ExcelDocument.Data',
                                                event.target.result
                                                    .replace('data:', '')
                                                    .replace(/^.+,/, '')
                                            );
                                        };
                                        reader.readAsDataURL(file);
                                    }}
                                />
                            </Paper>
                        </Grid>

                        {/* Buttons Section - Second Line, Split Horizontally */}
                        <Grid item xs={6} style={{ width: '100%' }}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Box position="relative">
                                        <PrimaryButton
                                            fullWidth
                                            type="submit"
                                            title="Upload"
                                            disabled={loading}
                                            className={classes.CustomPrimaryButtonStyle}
                                            style={{
                                                borderRadius: 12,
                                                padding: '12px 24px',
                                                fontSize: '16px',
                                                fontWeight: 'bold',
                                                minHeight: 48
                                            }}
                                        />
                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={classes.buttonProgress}
                                                style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    marginTop: -12,
                                                    marginLeft: -12,
                                                }}
                                            />
                                        )}
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* File format helper text */}
                        <Grid item xs={12}>
                            <Typography variant="h6" color="textSecondary" align="center">
                                Supported formats: .xlsx, .xls, .csv
                            </Typography>
                        </Grid>
                    </Grid>
                </Paper>
            </Form>
        );
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={setIsError}
        >
            <Formik
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={handleSubmit}
            >
                {UploadForm}
            </Formik>

            <Paper className={classes.PaperStyle} style={{ marginTop: 24, padding: 16 }}>
                <Typography>Total Records: {totalRecords}</Typography>
                <Typography color="primary">✅ Successful Records: {successRecords}</Typography>
                <Typography color="error">❌ Failed Records: {failedRecords}</Typography>
                {failedData.length > 0 && (
                    <Box mt={2}>
                        <Typography variant="h6" color="error">Failed Data:</Typography>
                        {failedData.map((item, idx) => (
                            <Typography key={idx}>
                                {idx + 1}. Row: {item.RowNumber}, Column: {item.ColumnName}, Reason: {item.Reason}
                            </Typography>
                        ))}
                    </Box>
                )}
            </Paper>

        </CustomContainer>
    );
};